import get from '@invitato/helpers/dist/getLocale';

export default {
  akad: get('Akad<br />Nikah', 'Wedding<br />Vows'),
  reception: get('Resepsi<br />Pernikahan', 'Wedding<br />Reception'),
  reminder: get('Ingatkan Acara', 'Remind Me'),
  location: get('Lihat Peta', 'See Location'),
};